import { graphql } from '../gql'

/**
 * GraphQL operations for orders.
 */

/** Query: Get full order detail. */
export const GetOrderDetail = graphql(`
	query GetOrderDetail($orderId: Int!) {
		order(id: $orderId) {
			id
			name
			dateOfServiceLocal
			purchaseOrder
			instructions
			linesOnSite
			cashOnDelivery
			status

			statusDetails {
				slug
				name
			}

			service {
				id
				name
			}

			planned {
				id
				inventory {
					id
					quantity
					item {
						id
						name
						consumable
						displayUnit
						visibility {
							operatorAssignment
						}
					}
				}
				schedule {
					id
					scheduleIndex
					startTime
					endTime
					duration
					pour {
						id
						name
						type {
							id
							name
						}
					}
					step
					metrics {
						key
						value
					}
				}
			}

			supplier {
				id
				name
				name2
				phones {
					id
					number
				}
			}

			customer {
				id
				name
			}

			site {
				id
				name
				name2
				address {
					street
					city
					state
					zip
					lat
					lng
					timezone
				}
				instructions
			}

			contacts {
				id
				default
				contact {
					id
					firstName
					lastName
					phones {
						id
						number
					}
				}
				role {
					id
					name
					slug
				}
			}

			terms {
				needsAcceptance
				accepted
				content {
					title
					body
					format
				}
			}

			cancellationReason
		}
	}
`)
